export default "__VITE_ASSET__64c4e420__"